import iTranslation from './Translation';
export * from './Translation';
export default iTranslation;
export const t = iTranslation.translate;
export const f = iTranslation.format;
//# sourceMappingURL=index.js.map